import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listarEncargadosAdmin } from '../../services/adminEncargados';
import AppShell from '../../components/layout/AppShell';
import EmptyState from '../../components/ui/EmptyState';

// ADMIN > Encargados: administrar los productores de usuarios ya
// aprobados. Cada encargado tiene siempre 1..N productores (nunca 0 — a
// diferencia del modelo de huertos descartado, aquí no hay modo legacy sin
// asignación posible).
function AdminEncargadosPage() {
  const navigate = useNavigate();

  const [encargados, setEncargados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    listarEncargadosAdmin().then((result) => {
      if (result.ok) {
        setEncargados(result.encargados);
      } else {
        setError(result.message);
      }
      setLoading(false);
    });
  }, []);

  return (
    <AppShell title="Encargados">
      <div className="flex flex-col gap-6">
        <div>
          <h1 className="text-xl font-bold text-gray-900">Encargados</h1>
          <p className="mt-1 text-sm text-gray-500">
            Selecciona un encargado para ver o cambiar los productores para los que está autorizado.
          </p>
        </div>

        {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-center text-sm text-red-700">{error}</p>}

        {loading ? (
          <p className="text-center text-sm text-gray-500">Cargando...</p>
        ) : encargados.length === 0 ? (
          <EmptyState message="No hay encargados registrados." />
        ) : (
          <div className="flex flex-col gap-3">
            {encargados.map((e) => (
              <div
                key={e.id}
                onClick={() => navigate(`/admin/encargados/${e.id}`)}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') navigate(`/admin/encargados/${e.id}`);
                }}
                className="cursor-pointer rounded-2xl border border-gray-100 bg-white p-4 shadow-sm transition-colors hover:border-green-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <p className="truncate font-medium text-gray-900">{e.nombre}</p>
                    <p className="mt-1 truncate text-sm text-gray-500">
                      {e.productores.length > 0 ? e.productores.map((p) => p.nombre).join(', ') : 'Sin productores'}
                    </p>
                    {!e.activo && <p className="mt-1 text-xs text-red-600">Encargado deshabilitado</p>}
                  </div>
                  <span className="inline-flex shrink-0 rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600">
                    {e.productores.length} productor{e.productores.length === 1 ? '' : 'es'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}

export default AdminEncargadosPage;
